import React from 'react';
import { Routes, Route, createRoutesFromElements, createBrowserRouter, RouterProvider } from 'react-router-dom';
import KioskPage from './KioskPage';
import OpenSurveyPage from './OpenSurveyPage';
import ErrorPage from './ErrorPage';
import NoMatchPage from './NoMatchPage';
import LanguageParams from './LanguageParams.jsx';
import SurveyLayout from '../layouts/SurveyLayout';
import SurveyPage from './SurveyPage';
import SubmitPage from './SubmitPage';
import ThankYouPage from './ThankYouPage';
import ResultPage from './ResultsPage';
import ExpiredPage from './ExpiredPage';
import {
  ERROR_ROUTE,
  KIOSK_ROUTE,
  OPEN_SURVEY_ROUTE,
  SURVEY_ROUTE,
  SURVEY_SUBMIT_ROUTE,
  SURVEY_THANKYOU_ROUTE,
  SURVEY_RESULT_ROUTE,
  SURVEY_EXPIRED_ROUTE,
} from '../constants/routes';

const createManualRoutes = () => {
  return createRoutesFromElements(
    <Route element={<LanguageParams />}>
      <Route path={KIOSK_ROUTE} element={<KioskPage />} />
      <Route path={`${OPEN_SURVEY_ROUTE}/*`} element={<OpenSurveyPage />} />
      <Route path={`${SURVEY_ROUTE}/*`} element={<SurveyRouter />} />
      <Route path={ERROR_ROUTE} element={<ErrorPage />} />
      <Route path="*" element={<NoMatchPage />} />
    </Route>,
  );
};

const createRouter = () => {
  const manualRoutes = createManualRoutes();
  return createBrowserRouter(manualRoutes, {
    future: {
      v7_relativeSplatPath: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_fetcherPersist: true,
      v7_skipActionErrorRevalidation: true,
    },
  });
};

const AppRoutes = () => {
  const router = createRouter();
  return <RouterProvider router={router} future={{ v7_startTransition: true }} />;
};

const SurveyRouter = () => (
  <SurveyLayout>
    <Routes>
      <Route path="" element={<SurveyPage />} />
      <Route path={SURVEY_SUBMIT_ROUTE.slice(SURVEY_ROUTE.length)} element={<SubmitPage />} />
      <Route path={SURVEY_THANKYOU_ROUTE.slice(SURVEY_ROUTE.length)} element={<ThankYouPage />} />
      <Route path={SURVEY_RESULT_ROUTE.slice(SURVEY_ROUTE.length)} element={<ResultPage />} />
      <Route path={SURVEY_EXPIRED_ROUTE.slice(SURVEY_ROUTE.length)} element={<ExpiredPage />} />
    </Routes>
  </SurveyLayout>
);

export default AppRoutes;
